import * as React from 'react';

import Icon from './Icon';
import {IconProps} from './type';
import {Path} from 'react-native-svg';

const StarComponent: React.FC<IconProps> = props => (
  <Icon width={16} height={15} fill="none" {...props}>
    <Path
      fill={props?.fill || '#FFE475'}
      stroke={props?.fill || '#100E3A'}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.79 1.058a1 1 0 0 1 1.793 0l1.446 2.929a1 1 0 0 0 .752.547l3.235.473a1 1 0 0 1 .553 1.706L12.23 8.99a1 1 0 0 0-.288.885l.552 3.218a1 1 0 0 1-1.451 1.054l-2.891-1.52a1 1 0 0 0-.93 0l-2.892 1.52a1 1 0 0 1-1.45-1.054l.551-3.218a1 1 0 0 0-.288-.885L.803 6.713a1 1 0 0 1 .554-1.706l3.235-.473a1 1 0 0 0 .752-.547l1.446-2.93Z"
    />
  </Icon>
);
export default React.memo(StarComponent);
